import React, { useEffect, useState } from "react";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import DateRange from "./main/DateRange";
import { AccessToken, APIBaseURL } from "../Config";
import axios from "axios";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";
import { Link } from "react-router-dom";

export default function KYCL() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
 const [containerNo, setContainerNo] = useState("");
  const [equipmentId, setEquipmentId] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [equipments, setEquipments] = useState([]);

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/containers/transactions?page=` + page;
    if (equipmentId) {
      url += `&equipment_id=${equipmentId}`;
    }
    if (containerNo) {
      url += `&container_no=${containerNo}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          access_token: `${AccessToken}`,
        },
      });
      if (response.data && response.data.data) {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "info",
          text: "Something went wrong..!",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [equipmentId,start,end,containerNo]);

  
    const GetEquipment = async () => {
      setLoading(true);
      let url = `${APIBaseURL}/get/equipments`;
  
      try {
        const response = await axios.get(url);
        if (response.data && response.data.status == "success") {
          setEquipments(response.data.data);
        } else {
          Swal.fire({
            icon: "Info",
            text: `Something Want Wrong..! `,
            timer: 3000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: `Error in Data Fetch: ${error.message}`,
          timer: 3000,
          showConfirmButton: false,
        });
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      GetEquipment();
    }, []);

  const handleDataFilter = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setEquipmentId(formData.get("equipment_id") || "");
    setContainerNo(formData.get("container_no") || "");
    let range = formData.get("range");
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
    }
  };
  return (
    <>
     {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row justify-content-between my-3">
                  <h4 className="text-primary">Yard Transactions</h4>
                  <div className="card">
                    <div className="card-body">
                      <form action="" onSubmit={handleDataFilter}>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                id="container_no"
                                name="container_no"
                              />
                              <label htmlFor="container-name">
                                Container Number
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="equipment_id"
                                id="equipment_id"
                                className="form-select"
                              >
                                <option value="">Select Equipment</option>
                                {equipments?.map((equipment, i) => (
                                  <option value={equipment.equipment_name} key={i}>
                                    {equipment.equipment_name}
                                  </option>
                                ))}
                              </select>
                              <label for="equipment_id">Equipment Name</label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <DateRange />
                          </div>
                          <div className="col-md-2">
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                              onClick={() => window.location.reload()}
                            >
                              <i className="ri-restart-line ri-20px" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="row my-3">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>S No.</td>
                              <td>Container No.</td>
                              <td>Container Size</td>
                              <td>Equipment Name</td>
                              <td>From Location</td>
                              <td>To Location</td>
                              <td>Unlock Datetime</td>
                              {/* <td>Timestamp</td> */}
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data &&
                              data?.data.map((report, index) => (
                                <tr key={index}>
                                  <td>
                                    <span>{index + 1}</span>
                                  </td>
                                  <td>
                                    <span>{report.containerno}</span>
                                  </td>
                                  <td>
                                    {report?.container_master?.container_size ?? '-'}
                                    {/* {(isNaN(report.containersize) ? report?.container_master?.container_size : report.containersize) ?? '-'} */}
                                  </td>
                                  <td>
                                    <span>{report.equipmentid}</span>
                                  </td>
                                  <td>
                                    <span>{report.locklocation}</span>
                                  </td>
                                  <td>
                                    <span>{report.unlocklocation}</span>
                                  </td>
                                  <td>
                                    <span>
                                      {formatToDateTime(report.unlockdatetime)}
                                    </span>
                                  </td>
                                  {/* <td>
                                    <span>
                                      {formatToDateTime(report.created_at)}
                                    </span>
                                  </td> */}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {data && data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {data.from} to {data.to} of{" "}
                                  {data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {data &&
                                      data.links &&
                                      data.links.map((link, q) => {
                                        let showData =
                                          data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              data.current_page ==
                                                data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
